import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { Form, NumberInputFrom } from '@tencent/wb-ext-form';
import { FORM_CONFIGS, REGULATE_MIN, REGULATE_MAX } from '@framework/workbench/drawer/ui/picture/regulate/config';
import { FormItemName, IMultiDiffValue, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { IRegulateFeature } from './regulate-interface';

@Controller({ formItems: FORM_CONFIGS })
export class RegulateController {
    constructor(@Loader(IRegulateFeature) private loader: IDynamicLoader<IRegulateFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.PICTURE_FIX_RESET, 'content')
    public renderReset() {
        return this.feature.renderReset();
    }

    @Form(FormItemName.SHARPEN_SOFTEN, 'value')
    public getSharpenSoften(): number | IMultiDiffValue {
        return this.feature.getShownValue(
            INPUT_PROPS_CALLBACK_KEY.REGULATE,
            { sharpenSoften: this.feature.sharpenSoften },
        );
    }

    @Form(FormItemName.SHARPEN_SOFTEN, 'onChange')
    public changeSharpenSoften(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const { sharpenSoften } = this.feature.getValidValue(
            { sharpenSoften: value }, from,
            REGULATE_MAX, REGULATE_MIN,
        );
        this.feature.handleRegulateChange(sharpenSoften, 'sharpenSoften', from, dragEnd);
    }

    @Form(FormItemName.SHARPEN_SOFTEN, 'shouldDisabled')
    public shouldSharpenSoftenDisabled(): boolean {
        return this.feature.isGifOrSvg();
    }

    @Form(FormItemName.BRIGHTNESS, 'value')
    public getBrightness(): number | IMultiDiffValue {
        return this.feature.getShownValue(
            INPUT_PROPS_CALLBACK_KEY.REGULATE,
            { brightness: this.feature.brightness },
        );
    }

    @Form(FormItemName.BRIGHTNESS, 'onChange')
    public changeBrightness(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const { brightness } = this.feature.getValidValue({ brightness: value }, from, REGULATE_MAX, REGULATE_MIN);
        this.feature.handleRegulateChange(brightness, 'brightness', from, dragEnd);
    }

    @Form(FormItemName.BRIGHTNESS, 'shouldDisabled')
    public shouldBrightnessDisabled(): boolean {
        return this.feature.isGif();
    }

    @Form(FormItemName.CONSTRAST, 'value')
    public getContrast(): number | IMultiDiffValue {
        return this.feature.getShownValue(
            INPUT_PROPS_CALLBACK_KEY.REGULATE,
            { contrast: this.feature.contrast },
        );
    }

    @Form(FormItemName.CONSTRAST, 'onChange')
    public changeContrast(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const { contrast } = this.feature.getValidValue({ contrast: value }, from, REGULATE_MAX, REGULATE_MIN);
        this.feature.handleRegulateChange(contrast, 'contrast', from, dragEnd);
    }

    @Form(FormItemName.CONSTRAST, 'shouldDisabled')
    public shouldContrastDisabled(): boolean {
        return this.feature.isGif();
    }
}
